import axios from 'axios';
import { getCmsApiBaseUrl } from './api.config';

export interface ManualReviewRequest {
  manualReviewStatus: 'PASS' | 'FAIL';
  newReason?: string;
}

/**
 * Update manual review status for a session.
 * Pass liveData=true to target the production endpoint.
 * Authorization header is handled by the axios interceptor.
 */
export const updateManualReview = async (
  sessionId: string,
  data: ManualReviewRequest,
  liveData = false,
): Promise<void> => {
  const baseUrl = getCmsApiBaseUrl(liveData);
  await axios.post(`${baseUrl}/manual-review/${sessionId}`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
